import {AppState} from '../index';

export interface GameStep {
  rentaItemId: number;
  priceUsd: number;
  userPrice: number;
  completeIn: number;
  points: number;
}

export interface GameStepCurrent {
  number: number;
  stepData: null | GameStep;
  rentaItem: null | GameRentaItem;
}

export interface GameOrient {
  label: string;
  subway: number;
  subway_branch_id: number;
}

export interface GameRentaItem {
  address: string;
  district: string;
  area: string;
  description: string;
  details: string;
  floor: string;
  images: string[];
  orients: GameOrient[];
  rooms: string;
}

export interface GamePlan {
  points: number;
  totalScore: number;
  steps: GameStep[];
  gamePlanData: Record<number, GameRentaItem>;
  priceMin: number;
  priceMax: number;
  title: string;
  subTitle: string;
  rules: string;
}

export interface LeaderboardUser {
  name: string;
  avatar: string;
  score: number;
  url: string;
}

export interface Leaderboard {
  topList: LeaderboardUser[];
}

interface State {
  gamePlan: null| GamePlan;
  gameStarted: boolean;
  currentStepNumber: number;
  isExitDialogOpened: boolean;
}

const initState: State = {
  gamePlan: null,
  gameStarted: false,
  currentStepNumber: 0,
  isExitDialogOpened: false,
};

const START_GAME = '@game-quiz/start';
const UPDATE_GAME_PLAN = '@game-quiz/update';
const SET_CURRENT_STEP = '@quiz-game/current-step';
const EXIT_DIALOG_OPEN = '@quiz-game/exit-dialog-open';

interface UpdateGamePlan {
  type: typeof UPDATE_GAME_PLAN;
  data: null | GamePlan;
}

interface StartGame {
  type: typeof START_GAME;
  data: boolean;
}

interface SetCurrentStep {
  type: typeof SET_CURRENT_STEP;
  data: number;
}

interface SetExitDialogOpen {
  type: typeof EXIT_DIALOG_OPEN;
  data: boolean;
}

export type GamePlanAction =
  UpdateGamePlan | StartGame | SetCurrentStep | SetExitDialogOpen;

export const gameQuizReducer = (
  state: State = initState,
  action: GamePlanAction,
) => {
  switch (action.type) {
    case UPDATE_GAME_PLAN:
      return {
        ...state,
        gamePlan: action.data
      };

    case START_GAME:
      return {
        ...state,
        gameStarted: action.data,
      };

    case SET_CURRENT_STEP:
      return {
        ...state,
        currentStepNumber: action.data,
      };

    case EXIT_DIALOG_OPEN:
      return {
        ...state,
        isExitDialogOpened: action.data,
      };

    default:
      return state;
  }
};

export const updateGamePlan = (gamePlan: null | GamePlan) => {
  return {
    type: UPDATE_GAME_PLAN,
    data: gamePlan,
  };
};

export const getGamePlan = (state: AppState) =>
  state.gameQuiz.gamePlan;

export const startGame = () => {
  return {
    type: START_GAME,
    data: true,
  };
};

export const getGameStarted = (state: AppState) =>
  state.gameQuiz.gameStarted;

export const setCurrentStep = (step: number) => {
  return {
    type: SET_CURRENT_STEP,
    data: step,
  };
};

export const getCurrentStepNum = (state: AppState) =>
  state.gameQuiz.currentStepNumber;

export const setExitDialogOpen = (state: boolean) => {
  return {
    type: EXIT_DIALOG_OPEN,
    data: state
  };
};

export const isExitDialogOpened = (state: AppState) =>
  state.gameQuiz.isExitDialogOpened;
